// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"microphone-2"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M22 8C22 11.3137 19.3137 14 16 14C12.6863 14 10 11.3137 10 8C10 4.68629 12.6863 2 16 2C19.3137 2 22 4.68629 22 8Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M10 8C10 11.3137 12.6863 14 16 14L6.50007 21.5002C6.50007 21.5002 5.45836 22.457 3.50007 20.5002C1.54178 18.5433 2.50007 17.5002 2.50007 17.5002L10 8Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M16 14C12.6863 14 10 11.3137 10 8M16 14L6.50007 21.5002C6.50007 21.5002 5.45836 22.457 3.50007 20.5002C1.54178 18.5433 2.50007 17.5002 2.50007 17.5002L10 8M16 14C19.3137 14 22 11.3137 22 8C22 4.68629 19.3137 2 16 2C12.6863 2 10 4.68629 10 8","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M9 15L8 16","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-microphone-2')
export default class Microphone2Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'microphone-2',
    }
  }
}
